import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

/**
 * Ряд «Артикул / EAN» на сторінці товару.
 *
 * Horizon при звичайній зміні варіанта морфить лише сам `variant-picker`, а решту
 * блоків оновлюють окремі компоненти з події `variantUpdate`. Подія несе повний
 * документ нової відповіді (`detail.data.html`), тож свій шматок беремо звідти —
 * так само, як це робить темовий `product-inventory`. Розбирати JSON варіанта не
 * треба: `barcode` у ньому не гарантований.
 */
class TgProductIds extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#section()?.addEventListener(ThemeEvents.variantUpdate, this.updateIds);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#section()?.removeEventListener(ThemeEvents.variantUpdate, this.updateIds);
  }

  #section() {
    return this.closest('.shopify-section, dialog');
  }

  /**
   * @param {CustomEvent} event — подія зміни варіанта
   */
  updateIds = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    const fresh = event.detail.data.html.querySelector('tg-product-ids');
    if (!fresh) return;

    // Порожній варіант ховає весь ряд — атрибут морф не переносить, ставимо самі.
    this.hidden = fresh.hasAttribute('hidden');
    morph(this, fresh, { childrenOnly: true });
  };
}

if (!customElements.get('tg-product-ids')) {
  customElements.define('tg-product-ids', TgProductIds);
}
